import { Dispatch, Reducer } from "react";

import createDataContext from "../createDataContext";

import {
  FormActionType,
  FormActions,
  FormState,
  LocationSweatCommentPairs,
  PossibleTemperatureValue,
  SelectActivityAction,
  SelectAgeLocationPairAction,
  SelectTemperatureAction,
  TemperatureSelectType,
} from "./types";

const formReducer: Reducer<FormState, FormActions> = (
  state: FormState,
  action: FormActions
) => {
  switch (action.type) {
    case FormActionType.SELECT_AGE_LOCATION_PAIR: {
      if (action.payload.pairID !== "") {
        const selectedPair = state.ageLocationPairs.find(
          (pair) => pair.pairID === action.payload.pairID
        );

        return {
          ...state,
          selectedAgeLocationPair: selectedPair ?? "",
          ageLocationPair: selectedPair ?? null,
          selectedActivity: "",
          activity: null,
          temperatureSelectType: null,
          temperatureValue: null,
        };
      } else {
        return {
          ...state,
          selectedAgeLocationPair: "",
          ageLocationPair: null,
          selectedActivity: "",
          activity: null,
          temperatureSelectType: null,
          temperatureValue: null,
        };
      }
    }
    case FormActionType.SELECT_ACTIVITY: {
      const activity = action.payload.activity;

      let newTemperatureSelectType =
        activity !== ""
          ? activity?.fixedTemperatureRanges
            ? TemperatureSelectType.RANGE
            : TemperatureSelectType.SLIDER
          : null;

      let newTemperatureValue = null;
      if (
        state.temperatureSelectType === TemperatureSelectType.SLIDER &&
        state.temperatureSelectType === newTemperatureSelectType
      ) {
        newTemperatureValue = state.temperatureValue;
      }

      return {
        ...state,
        selectedActivity: activity,
        activity: activity !== "" ? activity : null,
        temperatureSelectType: newTemperatureSelectType,
        temperatureValue: newTemperatureValue,
      };
    }
    case FormActionType.SELECT_TEMPERATURE: {
      return {
        ...state,
        temperatureValue: action.payload.temperatureValue,
      };
    }
    default:
      return state;
  }
};

const selectAgeLocationPairByID =
  (dispatch: Dispatch<SelectAgeLocationPairAction>) =>
  (pairID: number | "") => {
    dispatch({
      payload: {
        pairID: pairID,
      },
      type: FormActionType.SELECT_AGE_LOCATION_PAIR,
    });
  };

const selectActivity =
  (dispatch: Dispatch<SelectActivityAction>) =>
  (activity: LocationSweatCommentPairs | "") => {
    dispatch({
      payload: {
        activity: activity,
      },
      type: FormActionType.SELECT_ACTIVITY,
    });
  };

const selectTemperature =
  (dispatch: Dispatch<SelectTemperatureAction>) =>
  (temperatureValue: PossibleTemperatureValue) => {
    dispatch({
      payload: {
        temperatureValue: temperatureValue,
      },
      type: FormActionType.SELECT_TEMPERATURE,
    });
  };

export const { Context, Provider } = createDataContext(
  formReducer,
  { selectAgeLocationPairByID, selectActivity, selectTemperature },
  new FormState()
);
